import { createSelector } from '@ngrx/store';

import { getRentDepositState } from '../reducers';
import { RentDepositState } from './rent-deposit.reducer';

export const getCurrentWizardStep = createSelector(
  getRentDepositState,
  (state: RentDepositState) => state.currentStepNumber
);

export const getRuvActionState = createSelector(
  getRentDepositState,
  (state: RentDepositState) => state.useRuvDepositActionState
);

export const getRentDepositInfo = createSelector(
  getRentDepositState,
  (state: RentDepositState) => state.rentDepositInfo
);
